import { Info } from "lucide-react";
import site from "../../data/site.json";

export const INDEPENDENCE_TEXT = site.independenceText;

export function IndependenceBanner() {
  return (
    <div data-testid="independence-banner" role="note" className="border-b border-slate-800 bg-slate-900">
      <p className="mx-auto flex max-w-6xl items-start justify-center gap-2 px-4 py-2.5 text-center text-xs leading-relaxed text-slate-300 sm:items-center sm:px-6">
        <Info aria-hidden="true" className="mt-0.5 h-3.5 w-3.5 shrink-0 text-emerald-500 sm:mt-0" />
        <span>{INDEPENDENCE_TEXT}</span>
      </p>
    </div>
  );
}
